export interface RailOperationQuestion {
    key: string,
    value: string,
    altValue?: string,
    tooltip?: string
}

const RailOperationQuestions = {
    TrainSerialNumber: {
        key: 'trainSerialNumber',
        value: 'Train Serial Number',
        altValue:'Type in Train Serial Number'
    },
    Date: {
        key: 'eventDate',
        value: 'Date',
    },
    Time: {
        key: 'eventTime',
        value: 'Time',
    },
    DurationOfDelay: {
        key: 'durationOfDelay',
        value: 'Duration Of Delay',
        altValue:'Enter duration in HH:mm'
    },
    DriversName: {
        key: 'driverName',
        value: 'Drivers Name',
        altValue: 'Type in Drivers Name'
    },
    DriversDepot: {
        key: 'driversDepot',
        value: 'Drivers Depot',
        altValue: 'Type in Drivers Depot'
    },
    TrainDetails: {
        key: 'TrainDetails',
        value: 'Train Details(Complete all Fields) Tick applicable box'
    },
    ALeadLoco: {
        key: 'leadLoco',
        value: 'A Lead Loco'
    },
    ATrailLoco: {
        key: 'trailLocoA',
        value: 'A Trail Loco'
    },
    BRemoteLoco: {
        key: 'remoteLoco',
        value: 'B Remote Loco'
    },
    BTrailLoco: {
        key: 'trailLocoB',
        value: 'B Trail Loco'
    },
    TrainBrakeType: {
        key: 'brakeType',
        value: 'Train Brake Type'
    },
    LeaderActive: {
        key: 'leaderActive',
        value: 'Leader Active'
    },
    EOT: {
        key: 'eotNo',
        value: 'EOT(Digitair) No.',
        altValue:'Type in EOT(Digitair) No.'
    },
    SpecificLocation: {
        key: 'SpecificLocation',
        value: 'Specific Location'
    },
    Line: {
        key: 'line',
        value: 'Line',
        altValue:'Type in Line'
    },
    KmPeg: {
        key: 'kmPeg',
        value: 'Km Peg',
        altValue: 'Type in Km Peg'
    },
    Loaded: {
        key: 'isLoaded',
        value: 'Loaded/Empty'
    },
    WeatherConditions: {
        key: 'weatherConditions',
        value: 'Weather Conditions',
        altValue: 'Type in Weather Conditions'
    },
    IncidentDetails: {
        key: 'incident',
        value: 'Incident Details'
    },
    Result: {
        key: 'result',
        value: 'Result'
    },
    SequenceOfEvents: {
        key: 'sequenceOfEvents',
        value:`Sequence Of Events, Actions/ Faults/ Damage.<br/>

        LEADER prompts. <br/>

        Train Condition i.e.Speed, dynamic brake,Auto brake,track profile etc.`,
        altValue:'List in detail: LEADER prompts, ATP info, faluts, alarams, messages, car numbers etc.'
    },
    RadiofaultDetails: {
        key: 'radioFaultType',
        value: 'Radio fault Details'
    },
    FaultArea: {
        key: 'FaultArea',
        value: 'Fault Area'
    },
    DetailsofECPB: {
        key: 'DetailsofECPB',
        value: 'Details of ECPB Alarms/Faults etc.'
    },
    ECPBPressures: {
        key: 'ECPBPressures',
        value: 'ECPB Pressures(if applicable)'
    },
    NoOfFlatBatteries: {
        key: 'NoOfFlatBatteries',
        value: 'Number Of flat batteries(if>10 contact MC and list car numbers).'
    },
    NoInoperableCars: {
        key: 'NoInoperableCars',
        value: 'Number inoperable cars:'
    },
    Percentageoperable: {
        key: 'percentageOperable',
        value: '% Operable',
        altValue: 'Type in % operable'
    },
    Supervisor: {
        key: 'supervisorName',
        value: 'Supervisor'
    },
    NoOfBp: {
        key: 'noOfBp',
        value: 'Bp'
    },
    NoOfRes: {
        key: 'rESPressure',
        value: 'Res'
    },
    NoOfBc: {
        key: 'noOfBc',
        value: 'Bc'
    },
    HandheldSerialNo: {
        key: 'handhelSerialNo',
        value: 'Handheld Serial No',
        altValue: 'Type in Handheld Serial No'
    },
    KmStart: {
        key: 'faultKmStart',
        value: 'Km Start',
        altValue: 'Type in Km Start'
    },
    KmFinish: {
        key: 'faultKmEnd',
        value: 'Km Finish',
        altValue: 'Type in Km Finish'
    },
}
export default RailOperationQuestions;